"use strict";Object.defineProperty(exports, "__esModule", {value: true});var t={tabsInfo:{selectedTabIndex:0},preLoadTabs:!1,setActiveTab:(e,a)=>({index:e,selectedTabProps:a})},s= exports.a =t;exports.a = s;
